import axios from 'axios';
import logger from './logService';

function setJwt(jwt) {
  axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
  axios.defaults.headers.common['Access-Control-Allow-Methods'] =
    'GET, POST, PATCH, PUT, DELETE, OPTIONS';
  axios.defaults.headers.common['Access-Control-Allow-Headers'] =
    'Origin, Content-Type,  Accept, X-Requested-With, X-Auth-Token';
}

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response && error.response.status >= 400 && error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
  }

  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
};
